<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/south-africa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/alto-wine-estate')">Alto Wine
                        Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer')">Kanonkop
                        Paul Sauer
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/meerlust-estate')">Meerlust Estate
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/savanha-wines')">Savanha Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/the-sadie-family-wines')">The
                        Sadie Family Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards')">
                        Thelema Mountain Vineyards
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/south-africa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Stellenbosch</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La gente considera Stellenbosch in Sud Africa come la Napa Valley in California. Situato a circa 50 chilometri nell'entroterra di Città del Capo, negoziare i produttori di Stellenbosch può essere difficile in quanto ce ne sono così tanti. E con la quantità arriva la qualità, in alcuni casi sorprendentemente buona. Questo è di gran lunga il punto di riferimento per i vini del Sudafrica, sede di molte delle grandi tenute tra cui The Sadie Family Winery. I vigneti sono fiancheggiati da montagne e beneficiano della fresca brezza marittima; questo non solo conferisce all'uva il potenziale per una lunga maturazione sulla vite, ma la rende anche magica su Instagram (se ti piace quel genere di cose). Sette diverse sottoregioni (cinque delle quali, Blaauwklippen River Valley, Somerset West, Simonsberg-Stellenbosch, Banghoek, Jonkershoek Valley, sono coerenti nella loro eccellenza. Ciò è senza dubbio dovuto al terroir ghiaioso e granitico superiore della regione, ideale per i loro deliziosi rossi. I terreni di arenaria a ovest della regione sono perfetti per la produzione del loro vino bianco cremoso. vecchio come il suolo di Napa, quindi consideralo quando soppesi i pro ei contro di entrambi i paesi.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Stellenbosch</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Die Menschen betrachten Stellenbosch im Vergleich zu Südafrika als das Napa Valley im Vergleich zu Kalifornien. Da Stellenbosch etwa 50 Kilometer landeinwärts von Kapstadt liegt, kann es eine Herausforderung sein, über die Produzenten zu verhandeln, da es so viele gibt. Und mit der Quantität geht Qualität einher – in manchen Fällen umwerfend gut. Dies ist bei weitem der Maßstab für südafrikanische Weine, die Heimat vieler großartiger Weingüter, darunter The Sadie Family Winery. Die Weinberge sind von Bergen umgeben und profitieren von der kühlenden Meeresbrise. Dies verleiht der Traube nicht nur das Potenzial für eine lange Reifung am Rebstock, sondern verleiht ihr auch Instagram-Magie (wenn Sie so etwas mögen). Sieben verschiedene Unterregionen (von denen fünf Blaauwklippen River Valley, Somerset West, Simonsberg-Stellenbosch, Banghoek und Jonkershoek Valley sind) zeichnen sich durchweg durch hervorragende Qualität aus. Dies ist zweifellos auf das hervorragende Kies- und Granit-Terroir der Region zurückzuführen, das sich ideal für ihre herrlichen Rotweine eignet. Die Sandsteinböden im Westen der Region eignen sich perfekt für die Herstellung ihres cremigen Weißweins. Denkanstoß: Die Granitberge sind etwa 600 Millionen Jahre alt, mehr als dreimal so alt Berücksichtigen Sie dies also bei der Abwägung der Vor- und Nachteile beider Länder.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Stellenbosch</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Les gens considèrent Stellenbosch en Afrique du Sud comme Napa Valley en Californie. Situé à environ 50 kilomètres à l'intérieur des terres du Cap, négocier avec les producteurs de Stellenbosch peut être difficile car ils sont si nombreux. Et avec la quantité vient la qualité - d'une qualité époustouflante dans certains cas. C'est de loin la référence pour les vins d'Afrique du Sud, qui abrite de nombreux grands domaines, dont The Sadie Family Winery. Les vignobles sont flanqués de montagnes et bénéficient de la brise maritime rafraîchissante ; non seulement cela donne au raisin un potentiel de longue maturation sur la vigne, mais cela le rend également magique sur Instagram (si vous aimez ce genre de chose). Sept sous-régions différentes (dont cinq, Blaauwklippen River Valley, Somerset West, Simonsberg-Stellenbosch, Banghoek, Jonkershoek Valley, sont constantes dans leur excellence. Cela est sans aucun doute dû au terroir supérieur de gravier et de granit de la région, idéal pour leurs beaux rouges. Les sols de grès à l'ouest de la région sont parfaits pour la production de leur vin blanc crémeux. comme le sol de Napa, alors considérez cela lorsque vous pesez le pour et le contre et les deux pays.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Stellenbosch</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        People consider Stellenbosch to South Africa as Napa Valley to California. Located about 50 kilometres inland from Cape Town, negotiating Stellenbosch’s producers can be challenging in that there are so many. And with quantity comes quality - jaw-droppingly good in some cases. This is by far the benchmark for South Africa wines, home to many of great the estates including The Sadie Family Winery. Vineyards are flanked by mountains and benefit from the cooling maritime breeze; not only does this give the grape potential for long ripening on the vine but also makes it Instagram magic (if you like that type of thing). Seven different subregions (five of which, Blaauwklippen River Valley, Somerset West, Simonsberg-Stellenbosch, Banghoek, Jonkershoek Valley, are consistent in their excellence. This is undoubtedly due to the superior gravel, granite terroir of the region, ideal for thier lovely reds. The sandstone soils to the west of the region are perfect for the production of their creamy white wine. Food for thought: the granite mountains are approximately 600 million years old, over 3 times as old as the soil in Napa, so consider that when weighing up the pros and cons and both countries.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Stellenbosch",
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Alto Wine Estate', src: '/wine-guide/south-africa/stellenbosch/alto-wine-estate'},
                {report: 'Kanonkop Paul Sauer', src: '/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer'},
                {report: 'Meerlust Estate', src: '/wine-guide/south-africa/stellenbosch/meerlust-estate'},
                {report: 'Savanha Wines', src: '/wine-guide/south-africa/stellenbosch/savanha-wines'},
                {report: 'The Sadie Family Wines', src: '/wine-guide/south-africa/stellenbosch/the-sadie-family-wines'},
                {
                    report: 'Thelema Mountain Vineyards',
                    src: '/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Stellenbosch fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich history and diverse winemaking traditions of the Stellenbosch wine region in South Africa, where world-renowned wineries and vineyards produce exceptional wines with unique character and style.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
